var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _vm.basicClaimId != -1
      ? _c("div", [
          _vm._m(0),
          _vm._v(" "),
          _c("div", { staticClass: "form-single" }, [
            _c("div", { staticClass: "title" }, [_vm._v("商品分类")]),
            _vm._v(" "),
            _c("div", { staticClass: "content" }, [
              _c("label", { staticClass: "mr20" }, [
                _vm._v(_vm._s(_vm.servcBasicCalim.goodsCatName || ""))
              ])
            ])
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "form-single" }, [
            _c("div", { staticClass: "title" }, [_vm._v("服务类型")]),
            _vm._v(" "),
            _c("div", { staticClass: "content" }, [
              _c("label", { staticClass: "mr20" }, [
                _vm._v(
                  _vm._s(
                    _vm.servcTypeMap[_vm.servcBasicCalim.servcTypeId] || ""
                  )
                )
              ])
            ])
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "form-single" }, [
            _c("div", { staticClass: "title" }, [_vm._v("服务分类")]),
            _vm._v(" "),
            _c("div", { staticClass: "content" }, [
              _c("label", { staticClass: "mr20" }, [
                _vm._v(_vm._s(_vm.servcBasicCalim.servcCatName || ""))
              ])
            ])
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "form-single" }, [
            _c("div", { staticClass: "title" }, [_vm._v("上门费(元)")]),
            _vm._v(" "),
            _c("div", { staticClass: "content" }, [
              _vm.servcBasicCalim.toDoorFee != null
                ? _c("label", { staticClass: "mr20" }, [
                    _vm._v(_vm._s(_vm.servcBasicCalim.toDoorFee.toFixed(2)))
                  ])
                : _c("label", { staticClass: "mr20" }, [_vm._v("0")])
            ])
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "form-single" }, [
            _c("div", { staticClass: "title" }, [_vm._v("服务费(元)")]),
            _vm._v(" "),
            _c("div", { staticClass: "content" }, [
              _vm.servcBasicCalim.generallFee != null
                ? _c("label", { staticClass: "mr20" }, [
                    _vm._v(_vm._s(_vm.servcBasicCalim.generallFee.toFixed(2)))
                  ])
                : _c("label", { staticClass: "mr20" }, [_vm._v("0")])
            ])
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "form-single" }, [
            _c("div", { staticClass: "title" }, [_vm._v("响应时长(分)")]),
            _vm._v(" "),
            _c("div", { staticClass: "content" }, [
              _c("label", { staticClass: "mr20" }, [
                _vm._v(_vm._s(_vm.servcBasicCalim.rspTimeMi || 0))
              ])
            ])
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "form-single" }, [
            _c("div", { staticClass: "title" }, [_vm._v("上门时长(分)")]),
            _vm._v(" "),
            _c("div", { staticClass: "content" }, [
              _c("label", { staticClass: "mr20" }, [
                _vm._v(_vm._s(_vm.servcBasicCalim.arriveTimeMi || 0))
              ])
            ])
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "form-single" }, [
            _c("div", { staticClass: "title" }, [_vm._v("维修时长(分)")]),
            _vm._v(" "),
            _c("div", { staticClass: "content" }, [
              _c("label", { staticClass: "mr20" }, [
                _vm._v(_vm._s(_vm.servcBasicCalim.repairedTimeMi || 0))
              ])
            ])
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "form-single" }, [
            _c("div", { staticClass: "title" }, [_vm._v("回询时限(分)")]),
            _vm._v(" "),
            _c("div", { staticClass: "content" }, [
              _c("label", { staticClass: "mr20" }, [
                _vm._v(_vm._s(_vm.servcBasicCalim.telCallTimeMi || 0))
              ])
            ])
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "form-single" }, [
            _c("div", { staticClass: "title" }, [_vm._v("质保期(天)")]),
            _vm._v(" "),
            _c("div", { staticClass: "content" }, [
              _c("label", { staticClass: "mr20" }, [
                _vm._v(_vm._s(_vm.servcBasicCalim.wrntPeriod || 0))
              ])
            ])
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "form-single" }, [
            _c("div", { staticClass: "title" }, [_vm._v("备注")]),
            _vm._v(" "),
            _c("div", { staticClass: "content" }, [
              _c("label", { staticClass: "mr20" }, [
                _vm._v(_vm._s(_vm.servcBasicCalim.memo || ""))
              ])
            ])
          ])
        ])
      : _vm._e(),
    _vm._v(" "),
    _vm.accClaimId != -1
      ? _c("div", [
          _vm._m(1),
          _vm._v(" "),
          _c("div", { staticClass: "form-single" }, [
            _c("div", { staticClass: "title" }, [_vm._v("商品分类")]),
            _vm._v(" "),
            _c("div", { staticClass: "content" }, [
              _c("label", { staticClass: "mr20" }, [
                _vm._v(_vm._s(_vm.servcAccCalim.goodsCatName || ""))
              ])
            ])
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "form-single" }, [
            _c("div", { staticClass: "title" }, [_vm._v("服务类型")]),
            _vm._v(" "),
            _c("div", { staticClass: "content" }, [
              _c("label", { staticClass: "mr20" }, [
                _vm._v(
                  _vm._s(_vm.servcTypeMap[_vm.servcAccCalim.servcTypeId] || "")
                )
              ])
            ])
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "form-single" }, [
            _c("div", { staticClass: "title" }, [_vm._v("服务分类")]),
            _vm._v(" "),
            _c("div", { staticClass: "content" }, [
              _c("label", { staticClass: "mr20" }, [
                _vm._v(_vm._s(_vm.servcAccCalim.servcCatName || ""))
              ])
            ])
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "form-single" }, [
            _c("div", { staticClass: "title" }, [_vm._v("配件名称")]),
            _vm._v(" "),
            _c("div", { staticClass: "content" }, [
              _c("label", { staticClass: "mr20" }, [
                _vm._v(_vm._s(_vm.servcAccCalim.name || ""))
              ])
            ])
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "form-single" }, [
            _c("div", { staticClass: "title" }, [_vm._v("规格要求")]),
            _vm._v(" "),
            _c("div", { staticClass: "content" }, [
              _c("label", { staticClass: "mr20" }, [
                _vm._v(_vm._s(_vm.servcAccCalim.spec || ""))
              ])
            ])
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "form-single" }, [
            _c("div", { staticClass: "title" }, [_vm._v("价格下限(元)")]),
            _vm._v(" "),
            _c("div", { staticClass: "content" }, [
              _vm.servcAccCalim.price != null && _vm.servcAccCalim.price != 0
                ? _c("label", { staticClass: "mr20" }, [
                    _vm._v(_vm._s(_vm.servcAccCalim.price.toFixed(2)))
                  ])
                : _c("label", { staticClass: "mr20" }, [_vm._v("无要求")])
            ])
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "form-single" }, [
            _c("div", { staticClass: "title" }, [_vm._v("价格上限(元)")]),
            _vm._v(" "),
            _c("div", { staticClass: "content" }, [
              _vm.servcAccCalim.price2 != null && _vm.servcAccCalim.price2 != 0
                ? _c("label", { staticClass: "mr20" }, [
                    _vm._v(_vm._s(_vm.servcAccCalim.price2.toFixed(2)))
                  ])
                : _c("label", { staticClass: "mr20" }, [_vm._v("无要求")])
            ])
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "form-single" }, [
            _c("div", { staticClass: "title" }, [_vm._v("备注")]),
            _vm._v(" "),
            _c("div", { staticClass: "content" }, [
              _c("label", { staticClass: "mr20" }, [
                _vm._v(_vm._s(_vm.servcAccCalim.memo || ""))
              ])
            ])
          ])
        ])
      : _vm._e()
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "content-caption dashed" }, [
      _c("div", { staticClass: "left fl" }, [
        _c("span", [
          _c("span", { staticClass: "color-laber" }),
          _vm._v("价格质量要求详情")
        ])
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "content-caption dashed" }, [
      _c("div", { staticClass: "left fl" }, [
        _c("span", [
          _c("span", { staticClass: "color-laber" }),
          _vm._v("配件要求详情")
        ])
      ])
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-2f83eead", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2f83eead","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/compo/servcClaim/AccAndBasicClaimInfo.vue
// module id = 2017
// module chunks = 1